pageId = 'page-subgroups-new'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.initManageMembers($page)
